<template>
  <div>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="#272727"
        depressed
        class="text-capitalize font-weight-bold rounded-sm green--text"
        height="30"
        width="120"
        @click="geolocate"
      >Lokasi Saya</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
    <br />
    <div>
      <!-- <h2>Search and add a pin</h2> -->
      <GmapAutocomplete
        single-line
        outlined
        :placeholder="'Cari Lokasi'"
        style="width:100%;"
        class="v-text-field"
        @place_changed="setPlace"
      />
    </div>
    <br />
    <GmapMap
      :center="center"
      :zoom="18"
      map-style-id="roadmap"
      :options="mapOptions"
      ref="mapRef"
      @click="handleMapClick"
      style="width:100%;  height: 200px;"
    >
      <GmapMarker
        :position="marker.position"
        :clickable="true"
        :draggable="true"
        @click="panToMarker"
        @drag="handleMarkerDrag"
      />
    </GmapMap>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "GoogleMap",
  data() {
    return {
      mapOptions: {
        disableDefaultUI: true,
        zoomControl: true
      },
      marker: { position: { lat: 45.508, lng: -73.587 } },
      center: { lat: 45.508, lng: -73.587 },
      currentPlace: null,
      markers: [],
      places: []
    };
  },
  mounted() {
    // await this.getStoreDetail()
    // console.log("detailStore map", this.detailStore);
    // console.log("provinces", this.provinces);
    if (this.detailStore) {
      let longitude = this.detailStore.store_longitude;
      let latitude = this.detailStore.store_latitude;
      if (latitude != "" && longitude != "") {
        latitude = parseFloat(latitude);
        longitude = parseFloat(longitude);
        // this.addMarker(latitude, longitude);

        this.center = { lat: latitude, lng: longitude };
        this.marker.position = {
          lat: latitude,
          lng: longitude
        };
        this.panToMarker();
        let data = {
          latitude: latitude,
          longitude: longitude
        };
        this.actLatLon(data);
      }
    }
  },
  computed: {
    ...mapState("storeSeller", ["detailStore"])
  },
  methods: {
    ...mapActions("storeSeller", ["actLatLon"]),
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
    },
    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      let data = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng()
      };
      this.actLatLon(data);

      // this.purchaseForm.header.header_recipient_latitude = data.latitude;
      // this.purchaseForm.header.header_recipient_longitude = data.longitude;

      // console.log(e);
    },
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      let data = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng()
      };
      this.actLatLon(data);

      // this.purchaseForm.header.header_recipient_latitude = data.latitude;
      // this.purchaseForm.header.header_recipient_longitude = data.longitude;
    },
    async setPlace(place) {
      this.currentPlace = await place;
      //   console.log("place", place);
      //   console.log("geometry", place.geometry.location.lat());
      this.center = await {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      let data = {
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      };
      this.actLatLon(data);
      this.marker.position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      this.panToMarker();
    },
    geolocate: function() {
      //   this.lokasi = "";
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        let data = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        this.actLatLon(data);
        //   await this.addMarker();
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.panToMarker();
      });
    }
  }
};
</script>